import { Icon, Tabs } from '@mui/material';
import NavbarTab, { NavbarTabType } from 'components/NavbarTab/NavbarTab';
import React from 'react';
import { useDeviceType } from 'contexts/ThemeContext/hooks/useDeviceType';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { TabItem } from 'features/navbar/types';

interface DesktopNavListProps {
  navItemList: TabItem[];
  selectedTab?: NavbarTabType;
  onTabChange?: (tabObject: TabItem) => void;
  tabContainerStyle?: React.CSSProperties;
  hideTabIndicator?: boolean;
}

export const NavList = ({
  navItemList,
  selectedTab,
  onTabChange,
  tabContainerStyle,
  hideTabIndicator,
}: DesktopNavListProps) => {
  const { isDesktop, isMobile } = useDeviceType();
  const { translation } = useTranslationContext();

  return (
    <Tabs
      TabIndicatorProps={{ hidden: hideTabIndicator }}
      sx={tabContainerStyle}
      value={selectedTab}
      onChange={(_, tabValue) => {
        const tabObject = navItemList.find((tabItem) => tabItem.tabValue === tabValue);
        onTabChange?.(tabObject ?? navItemList[0]);
      }}
      variant={isMobile ? 'fullWidth' : 'standard'}
    >
      {navItemList.map((tabItem: TabItem) => (
        <NavbarTab
          key={tabItem.label}
          label={translation(tabItem.label)}
          value={tabItem.tabValue}
          icon={<Icon component={tabItem.icon} />}
          iconPosition={isDesktop ? 'start' : 'top'}
          showBadge={tabItem.showBadge}
        />
      ))}
    </Tabs>
  );
};
